import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from 'ng-devui';
import { zip } from 'rxjs';
import {
  AlertDialogComponent,
  AlertDialogType,
} from 'src/app/modules/shared/components/alert-dialog/alert-dialog.component';
import {
  TableColumnConfig,
  TableColumnOption,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { JgInspSolutionSearchRequest } from 'src/app/modules/shared/models/jg/jg-insp-solution-search-request.model';
import { JgInspSolution } from 'src/app/modules/shared/models/jg/jg-insp-solution.model';
import {
  JgInspTypeListMap,
  JgInspTypeOptions,
} from 'src/app/modules/shared/models/jg/jg-insp-type.enum';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import {
  EventService,
  EventType,
} from 'src/app/modules/shared/providers/event.service';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OrderType } from 'src/app/modules/shared/providers/request/order-type.enum';
import { Page } from 'src/app/modules/shared/providers/request/page.type';
import { JgInspSolutionService } from 'src/app/modules/shared/services/jg-insp-solution.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { StaffOrganizationService } from 'src/app/modules/shared/services/staff-organization.service';
import { DialogJgSolutionAddComponent } from '../../../dialogs/dialog-jg-solution-add/dialog-jg-solution-add.component';
import { DialogJgSolutionEditComponent } from '../../../dialogs/dialog-jg-solution-edit/dialog-jg-solution-edit.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-insp-plan',
  templateUrl: './handover-insp-plan.component.html',
  styleUrls: ['./handover-insp-plan.component.scss'],
})
export class HandoverInspPlanComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;

  config?: TableConfig = new TableConfig();

  columnType = TableColumnType;

  searchRequest = new JgInspSolutionSearchRequest();
  recordList: JgInspSolution[] = [];

  sectionMap: { [id: number]: ProjectSection } = {};
  orgMap: { [id: number]: string } = {};
  sectionOptions: TableColumnOption[] = [];
  orgOptions: TableColumnOption[] = [];

  currentCheckList: boolean[] = [];

  calcResult = '';
  firstSortOrderKey = '';

  /**
   * 分页器配置
   * @memberof AdminComponent
   */
  pager = this.globalService.recoverPager();
  timeout: any = undefined;
  get withToken() {
    return '?token=' + this.globalService.token;
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private globalService: GlobalService,
    private modalService: ModalService,
    private projectSectionService: ProjectSectionService,
    private staffOrganizationService: StaffOrganizationService,
    private jgInspSolutionService: JgInspSolutionService,
    private events: EventService,
  ) {}

  get canWrite(): boolean {
    if (location.href.indexOf('#/open') > -1) {
      const query = window.location.href.split('?')[1] ?? '';
      const params = new URLSearchParams(query);
      return params.get('writeable') === 'true';
    }
    return this.globalService.writeAbleByUrl('/handover/plan');
  }

  firstSortOrderKeyChange($event: string) {
    this.firstSortOrderKey = $event;
  }

  getAllSection() {
    zip(
      this.projectSectionService.findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
        type: OrganizationType.JG_CHECK,
      }),
      this.staffOrganizationService.findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
        type: OrganizationType.JG_CHECK,
      }),
    ).subscribe(([sections, orgs]) => {
      for (const item of sections ?? []) {
        this.sectionMap[item.id!] = item;
        this.sectionOptions.push({
          label: item.name!,
          value: item.id!,
        });
      }
      for (const item of orgs ?? []) {
        this.orgMap[item.id!] = item.name!;
        this.orgOptions.push({
          label: item.name!,
          value: item.id!,
        });
      }
      this.initConfig();
    });
  }

  ngOnInit(): void {
    this.getAllSection();
  }

  private initConfig() {
    const columns: TableColumnConfig[] = [
      {
        name: '交工检测标段',
        key: 'jgSectionId',
        type: TableColumnType.options,
        options: this.sectionOptions,
        width: 100,
        queryable: true,
        queryKey: 'jgSectionId',
        patternStr: 'C7f7f7f',
        sortable: true,
        sortKey: 'jgSectionIdOrder',
        sortDefault: OrderType.ASC,
        sortOrder: 1,
      },
      {
        name: '检测单位',
        key: 'organizationId',
        type: TableColumnType.options,
        options: this.orgOptions,
        width: 320,
        queryable: true,
        queryKey: 'organizationId',
        align: 'left',
        patternStr: 'E-320',
      },
      {
        name: '交工检测类型',
        key: 'jgInspTypesDisplay',
        type: TableColumnType.text,
        options: JgInspTypeOptions,
        queryType: TableColumnType.options,
        align: 'left',
        width: 240,
        queryable: true,
        queryKey: 'jgInspType',
        patternStr: 'B',
      },
      {
        name: '方案名称',
        key: 'name',
        type: TableColumnType.text,
        width: 700,
        align: 'left',
        queryable: true,
        queryKey: 'name',
        patternStr: 'E+700',
        preview: {
          style: () => 'primary',
          callback: (row: number) => {
            this.viewReport(this.recordList[row]);
          },
        },
      },
      {
        name: '备注',
        key: 'comment',
        type: TableColumnType.text,
        width: 120,
        align: 'left',
        patternStr: 'E+120',
      },
      // {
      //   name: '上传日期',
      //   key: 'uploadTime',
      //   type: TableColumnType.date,
      //   width: 90,
      //   queryable: true,
      //   queryKey: 'uploadTime',
      //   timeFormat: 'YYYY-MM-dd',
      //   patternStr: 'TSyyyy-MM-DD',
      //   sortable: true,
      //   sortKey: 'uploadTimeOrder',
      //   sortDefault: OrderType.DESC,
      // },
      {
        name: '操作',
        key: '',
        type: TableColumnType.actions,
        width: 80,
        dynamicActions: [
          {
            name: () => '编辑',
            style: () => 'primary',
            callback: (row: number) => {
              if (!this.canWrite) return;
              this.edit(row);
            },
          },
          {
            name: () => '删除',
            style: () => '',
            callback: (row: number) => {
              if (!this.canWrite) return;
              this.remove(row);
            },
          },
        ],
      },
      // 其他
    ];
    this.config = {
      hasIndex: true,
      columns,
      headerSize: 13,
      // freezeColumn: 3,
    };
    this.resetSearch();
  }

  ngOnDestroy(): void {
    this.hiddenHost.viewContainerRef.clear();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  category() {
    this.router.navigate(['..', 'category'], {
      relativeTo: this.activatedRoute,
    });
  }

  viewReport(report: JgInspSolution) {
    window.open(
      environment.fileHost + report.fileId + this.withToken,
      '_blank',
    );
  }

  searchRecord() {
    this.jgInspSolutionService
      .search(this.searchRequest, this.pager.pageIndex - 1, this.pager.pageSize)
      .subscribe((data: Page<JgInspSolution>) => {
        console.log(data);
        this.globalService.savePager(this.pager);
        this.currentCheckList = [];
        this.hiddenHost.viewContainerRef.clear();
        this.recordList = data.content;
        this.pager.total = data.totalElements;
        for (const record of this.recordList ?? []) {
          record.jgInspTypesDisplay = record
            .jgInspTypes!.map((type) => JgInspTypeListMap[type] ?? '未知类型')
            .join('、');
          // const codeList: string[] = [];
          // for (const section of record.projectSections ?? []) {
          //   codeList.push(
          //     this.sectionMap[section.sectionId!]?.name ?? '未知标段',
          //   );
          // }
          // if (codeList.length === this.sectionOptions.length) {
          //   record.sectionDisplay = '全部';
          // } else {
          //   record.sectionDisplay = codeList.join(',');
          // }
        }
      });
  }

  checkChange(checks: boolean[]) {
    this.currentCheckList = checks;
  }

  pageIndexChange(index: number) {
    this.pager.pageIndex = index;
    this.searchRecord();
  }

  pageSizeChange(size: number) {
    this.pager.pageSize = size;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  add(row?: number) {
    const results = this.modalService.open({
      backdropCloseable: false,
      component: DialogJgSolutionAddComponent,
      onClose: () => {},
      data: {
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.searchRecord();
          results.modalInstance.hide();
        },
      },
    });
  }

  edit(row: number) {
    const results = this.modalService.open({
      backdropCloseable: false,
      component: DialogJgSolutionEditComponent,
      onClose: () => {},
      data: {
        data: this.recordList[row],
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.searchRecord();
          results.modalInstance.hide();
        },
      },
    });
  }

  detail(row: number) {}

  remove(row: number) {
    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '删除',
        content: '确认删除？',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.confirm,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.removeRecord(row);
          results.modalInstance.hide();
        },
      },
    });
  }

  calcResultChange(result: string) {
    this.calcResult = result;
  }

  queryPanelStateChange(isOpen: boolean) {
    console.log(isOpen);
    if (isOpen === false) {
      this.resetSearch();
    }
  }

  resetSearch(force?: boolean) {
    if (!force) {
      this.timeout = setTimeout(() => {
        this.events.broadcast(EventType.PageCacheSearch);
      }, 50);
      return;
    }
    this.searchRequest = new JgInspSolutionSearchRequest();
    this.pager.pageIndex = 1;
    this.searchRequest.orderedSortFields = [
      'jgSectionIdOrder',
      'uploadTimeOrder',
    ];
    this.searchRequest.updateTimeOrder = OrderType.DESC;
    this.searchRequest.jgSectionIdOrder = OrderType.ASC;
    this.searchRecord();
  }

  private prepareSearch(data: any) {
    this.searchRequest = new JgInspSolutionSearchRequest();
    Object.assign(this.searchRequest, data);
    if (this.firstSortOrderKey === 'jgSectionIdOrder') {
      this.searchRequest.orderedSortFields = [
        'jgSectionIdOrder',
        'uploadTimeOrder',
      ];
    } else if (this.firstSortOrderKey === 'uploadTimeOrder') {
      this.searchRequest.orderedSortFields = [
        'uploadTimeOrder',
        'jgSectionIdOrder',
      ];
    }
  }

  searchClick(data: any) {
    this.prepareSearch(data);
    this.searchRecord();
  }

  afterEdit(data: { row: number; key: string }) {
    const { row, key } = data;
    this.editRecord(row);
  }

  batchChangeEnable() {
    let selectCount = 0;
    let selectedIndex = -1;
    const ids: number[] = [];
    for (let i = 0; i < this.currentCheckList.length; i++) {
      if (this.currentCheckList[i]) {
        selectedIndex = i;
        selectCount++;
        ids.push(this.recordList[i].id!);
      }
    }
    if (selectCount === 0) {
      return;
    }

    let content = `选中的${selectCount}个项目`;

    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '启停选中',
        content,
        hint: '批量设置为',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'primary',
        type: AlertDialogType.option,
        options: [
          {
            value: 1,
            name: '启用',
          },
          {
            value: 0,
            name: '停用',
          },
        ],
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: (result: number) => {
          // this.updateRecordBatched({
          //   idList: ids,
          //   enabled: +result,
          // });
          results.modalInstance.hide();
        },
      },
    });
  }

  batchRemove() {
    let selectCount = 0;
    let selectedIndex = -1;
    const ids: number[] = [];
    for (let i = 0; i < this.currentCheckList.length; i++) {
      if (this.currentCheckList[i]) {
        selectedIndex = i;
        selectCount++;
        ids.push(this.recordList[i].id!);
      }
    }
    if (selectCount === 0) {
      return;
    }

    let content = `确认删除选中的${selectCount}个项目`;

    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '删除选中',
        content,
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.prompt,
        onCancel: () => {
          console.log('cancel');
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.removeRecordBatched(ids);
          results.modalInstance.hide();
        },
      },
    });
  }

  // private updateRecordBatched(param: UpdateRequest) {
  //   this.omFormService.updateBatch(param).subscribe(() => {
  //     this.searchRecord();
  //   });
  // }

  private removeRecordBatched(ids: number[]) {
    // this.omFormService
    //   .removeBatch(ids)
    //   .subscribe((data: number) => {
    //     this.searchRecord();
    //   });
  }

  private removeRecord(index: number) {
    this.jgInspSolutionService
      .remove(this.recordList[index].id!)
      .subscribe((data: number) => {
        this.searchRecord();
      });
  }

  // private handleDataBeforeUpdate(
  //   taxAddSetting: AccountingBusiness
  // ): AccountingBusiness {
  //   const data = JSON.parse(JSON.stringify(taxAddSetting));
  //   data.policyFile = JSON.stringify(data.policyFileList);
  //   return data;
  // }

  private editRecord(index: number) {
    // this.omFormService
    //   .update(this.handleDataBeforeUpdate(this.recordList[index]))
    //   .subscribe(() => {
    //     this.searchRecord();
    //   });
  }
}
